<template>  
  <div id="playback-container" class="fixed inset-0 w-full h-[100dvh] bg-black">
    <BlockLayer v-if="videoStore.video.blocked" />
    <Player v-else-if="playerStore.started || (!videoStore.loading && videoStore.video.source && playerStore.available)" :autoplay="autoplay || playerStore?.startTime > 0" :time="time || playerStore?.startTime" :loop="loop" :isPlayback="true" class="h-full"/>
  </div>
</template>
<script setup>
import { VideoStore } from "@/front/stores/video_store.js";
import { PlaybackStore } from '@/front/stores/playback_store.js';
import { LeadCaptureStore } from '@/front/stores/lead_capture_store.js';
import { useRoute } from 'vue-router';
import { MessageComposer } from '@/front/composables/MessageComposer.js';
import Player from '@/front/components/player/Player.vue';
import BlockLayer from '@/front/components/BlockLayer.vue';
import { usePlaybackInitializer } from '@/front/composables/usePlaybackInitializer.js';
import { PlayerStore } from '@/front/stores/player_store.js';
const videoStore = VideoStore();
const playerStore = PlayerStore();
const playbackStore = PlaybackStore();
const leadCaptureStore = LeadCaptureStore();
const { receiveMessage } = MessageComposer();
const route = useRoute();
const { initialize } = usePlaybackInitializer();
import { setAppDocumentTitle, getUrlParameter } from '@/front/composables/UxComposer'


const autoplay = route.query.autoplay == "1" || route.query.t && route.query.autoplay != "0"
const time = route.query.t;
const loop = route.query.loop == "1";
let paymentStore = null;

onMounted(async () => {
  log.info(1,"🎬 Playback.vue mounted");
  window.addEventListener('message', receiveMessage);

  window.addEventListener('orientationchange', () => {
    // iOS
    document.getElementById('playback-container').style.height = '100dvh';
    setTimeout(() => {
      playerStore.updateRatios()
      log.info(1,"🔄 Playback.vue orientationchange", window.innerWidth, playerStore.isMobile);
    }, 50);
  });
  
  // Show loading state immediately if no preloaded data
  if (!window.__PRELOADED_VIDEO_DATA__) {
    log.info(1,"📡 No preloaded data, will fetch from API");
  }
  
  await videoStore.show(route.params.id, { 
    manage: false, 
    plink_id: route.query.plink_id,
    noview: !!route.query.noview || !!route.query.gostamp || !!route.query.doot
  }).catch(error => {
    log.info(1,"🔴 Playback error from show", error)
    playerStore.error = error;
    return;
  });

  if (!videoStore.video.id) {
    log.info(1,"🔴 Playback error after show", JSON.parse(JSON.stringify(videoStore.video)))
    playerStore.error = true;
    return;
  }

  log.info(1,"✅ Video loaded successfully:", videoStore.video.id, videoStore.video.title);
  setAppDocumentTitle(videoStore.video.tab_title || videoStore.video.title);

  if (videoStore.video.blocked) {
    log.info(1,"🚫 Video is blocked");
    return;
  }

  if (videoStore.video.capture_payment_point > -1) {
    log.info(1,"💳 Loading payment module");
    const { PaymentStore } = await import('@/front/stores/payment_store.js');
    paymentStore = PaymentStore();
    paymentStore.setConfig(videoStore.video);
  }

  videoStore.video.manage = false;
  if (getUrlParameter('speed')) {
    playerStore.speed = parseFloat(getUrlParameter('speed'));
  }

  log.info(1,"💟 Initializing playback from playback.vue")
  await initialize(route);

  if (videoStore.video.collect_geolocation) {
    log.info(1,"📍 Requesting geolocation");
    navigator.geolocation.getCurrentPosition(
      pos => {
        playbackStore.latitude = pos.coords.latitude;
        playbackStore.longitude = pos.coords.longitude;
        log.info(1,"📍 Geolocation captured");
      },
      error => {
        log.info(1,"📍 Geolocation error:", error.message);
      },
      {maximumAge:60000, timeout:5000, enableHighAccuracy:true}
    );
  }
  
  log.info(1,"🎉 Playback initialization complete");
});
</script>